import { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'How do I choose the right online casino in the UK?',
      answer: 'When selecting an online casino, consider factors such as UK Gambling Commission licensing, game variety, bonus terms and conditions, payment methods, withdrawal speeds, and customer support quality. We review all these aspects in our detailed casino analyses to help you make an informed decision.'
    },
    {
      question: 'Are the casinos on Crown Jackpot safe and licensed?',
      answer: 'Yes, absolutely. Every casino featured on Crown Jackpot holds a valid UK Gambling Commission license, which ensures strict regulation, player protection, and fair gaming practices. We only recommend operators that meet the highest standards of security and responsible gambling.'
    },
    {
      question: 'What welcome bonuses can I expect?',
      answer: 'Welcome bonuses vary by casino but typically include deposit matches (e.g., 100% up to a certain amount), free spins on popular slots, and sometimes no-deposit bonuses. Always read the terms and conditions carefully, as bonuses come with wagering requirements that must be met before withdrawal.'
    },
    {
      question: 'How quickly can I withdraw my winnings?',
      answer: 'Withdrawal times depend on the casino and payment method chosen. E-wallets like PayPal and Skrill typically process within 24 hours, while bank transfers may take 3-5 business days. We always highlight withdrawal speeds in our reviews to help you choose casinos that prioritize fast payouts.'
    },
    {
      question: 'Do you receive commission from casinos?',
      answer: 'Some of the links on our site are affiliate links, meaning we may receive a commission if you click through or sign up. However, this never affects our editorial independence, reviews, or ratings. We maintain strict editorial standards and only recommend casinos we genuinely believe offer value to players.'
    },
    {
      question: 'Is online gambling legal in the UK?',
      answer: 'Yes, online gambling is fully legal and regulated in the UK. The UK Gambling Commission oversees all licensed operators to ensure fair play, player protection, and responsible gambling practices. All casinos featured on our site are properly licensed and compliant with UK regulations.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-pink-50 via-white to-green-50">
      <div className="container mx-auto">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-pink-500 to-green-500 rounded-full mb-4">
              <HelpCircle className="w-8 h-8 text-white" />
            </div>
            <h2 className="pb-2 text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-pink-600 to-green-600 bg-clip-text text-transparent">
              Frequently Asked Questions
            </h2>
            <p className="text-xl text-gray-700">
              Everything you need to know about online casinos in the UK
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="glass-strong rounded-2xl overflow-hidden">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-white/20 transition-colors"
                >
                  <span className="text-lg font-semibold text-gray-800 pr-4">{faq.question}</span>
                  <ChevronDown
                    className={`w-6 h-6 text-gray-600 flex-shrink-0 transform transition-transform ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <div className="px-6 pb-5 text-gray-700 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;

